import { useEffect } from "react";

interface AssetsLoaderProps {
  styles?: string[];
  scripts?: string[];
}

const AssetsLoader: React.FC<AssetsLoaderProps> = ({ styles = [], scripts = [] }) => {
  useEffect(() => {

    console.log("Loading styles and scripts...");

    // Ajouter les liens CSS
    const links: HTMLLinkElement[] = styles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    // Ajouter les scripts JS
    const scriptElements: HTMLScriptElement[] = scripts.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      document.body.appendChild(script);
      return script;
    });

    // Nettoyage lors du démontage
    return () => {
      links.forEach((link) => document.head.removeChild(link));
      scriptElements.forEach((script) => document.body.removeChild(script));
    };
  }, [styles, scripts]);

  return null;
};

export default AssetsLoader;
